export const soClaimHeaderOptions = [
  { label: 'Limits of Liabilty', value: 'Limits of Liabilty', callback: 'onClickLol' }
];
export const ellipsisRowOptions = [
  { label: 'Edit', value: 'Edit', callback: 'onRowEdit' },
  { label: 'Delete ', value: 'Delete', callback: 'onRowDelete' },
  { label: 'Create Sub Claim ', value: 'Create Sub Claim', callback: 'onRowCreateSubClaim' }
];
